import USER_TYPE from '../constants/user-type';
import logError from '../utilities/logging/log-error';

//

const API_HOST = process.env.REACT_APP_API_HOST || '';
const LIVE_HOST = process.env.REACT_APP_LIVE_HOST || '';
const PROGRESS_HOST = process.env.REACT_APP_PROGRESS_HOST || '';

const ENDPOINT_NAMES = {
  answerQuestion: 'answer_question',
  assessmentDetail: 'assessment_detail',
  assessmentInvites: 'assessment_invites',
  assessmentMetadata: 'assessment_metadata',
  assessmentSkill: 'assessment_skill',
  assessments: 'assessments',
  assessmentReset: 'assessment_reset',
  assignmentAssessments: 'assignment_assessments',
  associateAssessment: 'associate_assessment',
  clientCourses: 'client_courses',
  clientSubscriptions: 'client_subscriptions',
  createInstantChat: 'create_instant_chat',
  dayOrchestratorAssessments: 'day_orchestrator_assessments',
  instantChatLanguages: 'instant_chat_languages',
  assessmentSubjects: 'assessment_subjects',
  nextQuestion: 'next_question',
  onlineSession: 'online_session',
  onlineSessionUsage: 'online_session_usage',
  sessionChapter: 'session_chapter',
  sessionChapters: 'session_chapters',
  sessionEventDetails: 'session_event_details',
  studentAssignment: 'student_assignment',
  studentAssignmentAssessments: 'student_assignment_assessments',
  studentAssignments: 'student_assignments',
  skills: 'assessment_dx_skills',
  skillAssessments: 'skill_assessment',
  studentAssessment: 'student_assessment',
  studentSchedule: 'student_schedule',
  studentSessionDetail: 'student_session_detail',
  studentSessions: 'student_sessions',
  studentSkillAssessments: 'student_skill_assessments',
  studentSkillProgress: 'student_skill_progress',
  studentSubject: 'student_subject',
  studentSubjectAssessments: 'student_subject_assessment',
  studentSubjects: 'student_subjects',
  studySupportEssay: 'student_essay',
  studySupportEssays: 'student_essays',
  studySupportEssayDetail: 'student_essay_detail',
  studySupportEssayFeedback: 'student_essay_feedback',
  studySupportEssayRequest: 'study_support_essay_request',
  studySupportEssayRequests: 'study_support_essays',
  v3StudentSubjects: 'v3_student_subjects',
  vtwaTutoringSession: 'vtwa_tutoring_session',
  translate: 'translate',
};

//

function _addQueryStringFilters(params) {
  if (params.standardId) {
    return `?standard_type=${params.standardId}`;
  }

  return '';
}

// eslint-disable-next-line complexity
function _getPath(name, params) {
  switch (name) {
    case ENDPOINT_NAMES.answerQuestion:
      return `${API_HOST}/v3/answer_question`;

    case ENDPOINT_NAMES.assessmentDetail:
      return `${API_HOST}/v1/assessments/${params.assessmentId}`;

    case ENDPOINT_NAMES.assessmentInvites:
      return `${API_HOST}/v2/assessment_invites`;

    case ENDPOINT_NAMES.assessmentMetadata:
      return `${API_HOST}/v3/assessment_metadata?assessment_id=${params.assessmentId}`;

    case ENDPOINT_NAMES.assessmentSkill:
      return `${API_HOST}/v1/assessment_dx/skills/${params.skillId}`;

    case ENDPOINT_NAMES.assessments:
      return `${API_HOST}/v3/assessments`;

    case ENDPOINT_NAMES.assessmentReset:
      return `${PROGRESS_HOST}/v3/learn-lab/progress/students/${params.studentId}/assessments/${params.assessmentId}/reset`;

    case ENDPOINT_NAMES.assignmentAssessments:
      return (
        `${PROGRESS_HOST}/v3/learn-lab/progress/students` +
        `/${params.studentId}/assignments/${params.assignmentId}/assessments`
      );

    case ENDPOINT_NAMES.associateAssessment:
      return `${PROGRESS_HOST}/v1/learn-lab/progress/students/${params.studentId}/associate_with_assessment`;

    case ENDPOINT_NAMES.clientCourses:
      return `${API_HOST}/v2/courses?client_id=${params.clientUuid}`;

    case ENDPOINT_NAMES.clientSubscriptions:
      return `${API_HOST}/v1/users/${params.clientUid}/subscriptions`;

    case ENDPOINT_NAMES.dayOrchestratorAssessments:
      return `${API_HOST}/v3/learn-lab/progress/students/${params.studentId}/assessments`;

    case ENDPOINT_NAMES.instantChatLanguages:
      return `${API_HOST}/vtwa/v5/desired_placements/instant_chat_languages`;

    case ENDPOINT_NAMES.assessmentSubjects:
      return `${PROGRESS_HOST}/v3/learn-lab/progress/subjects?filters=${params.filters.join(',')}`;

    case ENDPOINT_NAMES.nextQuestion:
      return `${API_HOST}/v3/answer_question/assessments/${params.assessmentId}`;

    case ENDPOINT_NAMES.onlineSession:
      return `${API_HOST}/v2/online_sessions/${params.sessionId}`;

    case ENDPOINT_NAMES.onlineSessionUsage:
      return `${LIVE_HOST}/v2/online_sessions/usage?student_uuid=${params.studentUuid}&from_date=${params.fromDate}&to_date=${params.toDate}&session_type=${params.sessionType}`;

    case ENDPOINT_NAMES.createInstantChat:
      return `${LIVE_HOST}/v2/online_sessions/create_instant_chat`;

    case ENDPOINT_NAMES.sessionChapters:
      return `${LIVE_HOST}/v2/recordings/${params.recordingId}/chapters`;

    case ENDPOINT_NAMES.sessionChapter:
      return `${LIVE_HOST}/v2/recordings/${params.recordingId}/chapters/${params.chapterId}`;

    case ENDPOINT_NAMES.studentAssignment:
      return `${PROGRESS_HOST}/v1/learn-lab/progress/students/${params.studentId}/assignments/${params.assignmentId}`;

    case ENDPOINT_NAMES.studentAssignmentAssessments:
      return `${PROGRESS_HOST}/v3/learn-lab/progress/students/${params.studentId}/assignments/${params.assignmentId}/assessments`;

    case ENDPOINT_NAMES.studentAssignments:
      return `${PROGRESS_HOST}/v1/learn-lab/progress/students/${params.studentId}/assignments`;

    case ENDPOINT_NAMES.studentAssessment: {
      return `${PROGRESS_HOST}/v3/learn-lab/progress/students/${params.studentId}/assessments/${params.assessmentId}`;
    }

    case ENDPOINT_NAMES.studentSessionDetail:
      return `${LIVE_HOST}/v2/me/online_sessions/${params.sessionId}`;

    case ENDPOINT_NAMES.studentSessions:
      return `${LIVE_HOST}/v2/me/online_sessions`;

    case ENDPOINT_NAMES.studentSchedule:
      return `${API_HOST}${
        params?.userType === USER_TYPE.student
          ? '/v1/learn-lab/users/me/events'
          : '/v1/tutoring-schedule'
      }`;

    case ENDPOINT_NAMES.studentSkillAssessments:
      return `${PROGRESS_HOST}/v1/learn-lab/progress/students/${params.studentId}/skill_assessments`;

    case ENDPOINT_NAMES.studentSkillProgress:
      return `${PROGRESS_HOST}/v3/learn-lab/progress/students/${params.studentId}/skills/${params.skillId}`;

    case ENDPOINT_NAMES.studentSubject:
      return `${PROGRESS_HOST}/v1/learn-lab/progress/students/${params.studentId}/subjects/${
        params.subjectId
      }${_addQueryStringFilters(params)}`;

    case ENDPOINT_NAMES.studentSubjectAssessments:
      return `${PROGRESS_HOST}/v3/learn-lab/progress/students/${params.studentId}/subjects/${params.subjectId}/assessments`;

    case ENDPOINT_NAMES.studentSubjects:
      return `${PROGRESS_HOST}/v1/learn-lab/progress/students/${
        params.studentId
      }/subjects${_addQueryStringFilters(params)}`;

    case ENDPOINT_NAMES.studySupportEssay:
      return `${API_HOST}/v1/llp/essays/${params.essayId}`;

    case ENDPOINT_NAMES.studySupportEssays:
      return `${API_HOST}/v1/llp/essays`;

    case ENDPOINT_NAMES.studySupportEssayDetail:
      return `${API_HOST}/v1/essays/requests/${params.requestId}/detail`;

    case ENDPOINT_NAMES.studySupportEssayFeedback:
      return `${API_HOST}/v1/essays/requests/${params.requestId}/feedback`;

    case ENDPOINT_NAMES.studySupportEssayRequest:
      return `${API_HOST}/v1/essays/requests/${params.requestId}`;

    case ENDPOINT_NAMES.studySupportEssayRequests:
      return `${API_HOST}/v1/essays/requests?${
        params.studentId ? `student_uuid=${params.studentId}&` : ''
      }type=full`;

    case ENDPOINT_NAMES.v3StudentSubjects:
      return `${PROGRESS_HOST}/v3/learn-lab/progress/students/${
        params.studentId
      }/subjects${_addQueryStringFilters(params)}`;

    case ENDPOINT_NAMES.vtwaTutoringSession:
      return `${API_HOST}/vtwa/v5/online_sessions/${params.sessionId}/tutoring_session`;

    case ENDPOINT_NAMES.translate:
      return `${API_HOST}/v1/lex-utilities/translate`;

    default:
      logError(`[Unexpected Event]: Unknown endpoint requested: ${name}`);
  }
}

//

const endpoints = {
  get(name, params = {}) {
    return {
      key: [
        name,
        ...Object.values(params).filter((value) => value !== undefined && value !== null),
      ],
      path: _getPath(name, params),
    };
  },
};

// Exports
// -------

export { ENDPOINT_NAMES, endpoints };

export default endpoints;
